import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./slices/profileSlice";
import myTeamsSlice from "./slices/myTeamsSlice";
import historySlice from "./slices/historySlice"
import costCenterSlice from "./slices/costCenterSlice";
import selectUBTSlice from "./slices/selectUBTSlice";
import manageAccessSlice from "./slices/manageAccessSlice";
import searchUserReducer from "./slices/searchUserSlice";
import projectSlice from "./slices/projectSlice";
import pathToPerformanceReducer from './slices/pathToPerformanceSlice';
import employeeReducer from "./slices/employeeSlice";
import membersReducer from "./slices/memberSlice";
import teamsReportSlice from "./slices/teamsReportSlice";
import pipListSlice from "./slices/pipListSlice";
import pipDetailsSlice from "./slices/projectDetailsSlice";
import testsOfChangeSlice from "./slices/testsOfChangeSlice";
import testDataSeriesSlice from "./slices/testDataSeriesSlice";
import ratingSourceReducer from "./slices/ratingSourceSlice";
import shiftLookupReducer from "./slices/shiftLookupSlice";
import manageProjectSlice from "./slices/ManageProjectSlice";
import teamReportSlice from "./slices/teamReportSlice";
import teamDocumentSlice from "./slices/teamDocumentSlice";
import reportReducer from "./slices/reportSlice";


export const store = configureStore({
  reducer: {
    profile: profileReducer,
    myTeamsSlice: myTeamsSlice,
    history: historySlice,
    project: projectSlice,
    costCenter: costCenterSlice,
    selectUBTSlice: selectUBTSlice,
    manageAccess: manageAccessSlice,
    searchUser: searchUserReducer,
    pathToPerformance: pathToPerformanceReducer,
    employee: employeeReducer,
    membersSlice: membersReducer,
    teamsReport: teamsReportSlice,
    pipListSlice: pipListSlice,
    pipDetailsSlice: pipDetailsSlice,
    testsOfChangeSlice: testsOfChangeSlice,
    testDataSeriesSlice: testDataSeriesSlice,
    ratingSource: ratingSourceReducer,
    shiftLookup: shiftLookupReducer,
    manageProjectSlice: manageProjectSlice,
    teamReportSlice: teamReportSlice,
    teamDocumentSlice: teamDocumentSlice,
    reportSlice: reportReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
